import { handleEmbed } from './embed';

class ConsentOverlay {
  constructor(params) {
    this.container = params.container;
    this.nameSpace = params.nameSpace;
    this.consentType = this.container.dataset.consentType;
    this.consentSubtype = this.container.dataset.consentSubtype;
    this.acceptOnceBtn =
      params.acceptOnceBtn ||
      this.container.querySelector('[data-accept="once"]');
    this.acceptAlwaysBtn =
      params.acceptAlwaysBtn ||
      this.container.querySelector('[data-accept="always"]');
    this.revokeBtn =
      params.revokeBtn || this.container.querySelector('[data-revoke]');
    this.activeClass = params.activeClass || 'is-active';
    this.onActivation = params.onActivation;
    this.onDeactivation = params.onDeactivation;
  }

  activateContent = container => {
    const isActive = container.classList.contains(this.activeClass);

    if (!isActive) {
      container.classList.add(this.activeClass);
      this.onActivation &&
        // TODO: check consentSubtype per container, instead of using the subType from the first container for every container
        // this.onActivation(container, this.consentType, this.consentSubtype);
        this.onActivation(
          container,
          this.consentType,
          container.dataset.consentSubtype
        );
    }
  };

  deactivateContent = container => {
    container.classList.remove(this.activeClass);
    this.onDeactivation &&
      // TODO: check consentSubtype per container, instead of using the subType from the first container for every container
      // this.onDeactivation(container, this.consentType, this.consentSubtype);
      this.onDeactivation(
        container,
        this.consentType,
        container.dataset.consentSubtype
      );
  };

  toggleAll = () => {
    const containers = document.querySelectorAll(
      `[data-consent-type=${this.consentType}]`
    );
    containers.forEach(container => {
      if (this.isConsentTypeEnabled()) {
        this.activateContent(container);
      } else {
        this.deactivateContent(container);
      }
    });
  };

  isConsentTypeEnabled = () =>
    window.localStorage.getItem(
      `${this.nameSpace}-${this.consentType}-enabled`
    );

  bindEvents = () => {
    this.acceptOnceBtn &&
      this.acceptOnceBtn.addEventListener('click', () => {
        this.activateContent(this.container);
      });
    this.acceptAlwaysBtn &&
      this.acceptAlwaysBtn.addEventListener('click', () => {
        window.localStorage.setItem(
          `${this.nameSpace}-${this.consentType}-enabled`,
          true
        );
        this.toggleAll();
      });
    this.revokeBtn &&
      this.revokeBtn.addEventListener('click', () => {
        if (this.isConsentTypeEnabled()) {
          window.localStorage.removeItem(
            `${this.nameSpace}-${this.consentType}-enabled`
          );
          this.toggleAll();
        } else {
          this.deactivateContent(this.container);
        }
      });
  };

  init = () => {
    // if there is a key for the current consentType in localStorage, i.e. a user has already given his*her consent: hide the overlay and activate the content
    if (this.isConsentTypeEnabled()) {
      this.toggleAll();
    }
    this.bindEvents();
  };
}

export { ConsentOverlay, handleEmbed };
